module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a3q"
  }, [_c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSpCorrect),
      expression: "showSpCorrect"
    }],
    staticClass: "correct",
    attrs: {
      "id": "eleCorrect"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner flexrow",
    class: _vm.cssLayoutID
  }, [_c('div', {
    staticClass: "toparea-image"
  }, [_c('div', {
    staticClass: "eleAni hide"
  }, [_vm._l((_vm.answersList), function(answer, index) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showQestionImage),
        expression: "showQestionImage"
      }],
      key: index,
      staticClass: "img-wrapper",
      attrs: {
        "id": 'Answer' + index,
        "ondragstart": "return false"
      },
      on: {
        "click": function($event) {
          return _vm.clickAnswer(answer, index)
        },
        "touchstart": function($event) {
          return _vm.onTouchStart(answer)
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": answer.image
      }
    })])]
  })], 2), _vm._v(" "), (_vm.isScrollIconVisible) ? _c('div', {
    staticClass: "icon-scroll"
  }) : _vm._e()]), _vm._v(" "), _c('CommonAct', {
    attrs: {
      "pathstep": _vm.pathstep,
      "activeType": _vm.activeType,
      "actChoice": false,
      "horizontalRow": true,
      "scriptSystems": _vm.scriptSystems,
      "needsSwiper": true,
      "isShowTextsParent": _vm.isShowTextsParent,
      "isShowVoicesParent": _vm.isShowVoicesParent,
      "isActivesParent": _vm.isActivesParent,
      "isCorrectsParent": _vm.isCorrectsParent,
      "isInCorrectsParent": _vm.isInCorrectsParent,
      "isCompleteParent": _vm.isCompleteParent,
      "changeActives": _vm.changeActives,
      "changeEndAct": _vm.changeEndAct,
      "changeIsCorrects": _vm.changeIsCorrects,
      "changeIsInCorrects": _vm.changeIsInCorrects,
      "changeIsComplete": _vm.changeIsComplete
    },
    on: {
      "actPinchIn": _vm.recieveActPinchIn
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-267848b7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-267848b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/A3Q.vue
// module id = 856
// module chunks = 1